import React from 'react';
import { FieldErrors } from 'react-hook-form';
import CalenderIcon from '../../assets/TimeIcon.svg';
import CalenderRedIcon from '../../assets/TimeRedIcon.svg';

function NewTimeIcon({ errors, name }: { errors: FieldErrors, name: string }) {
  return errors[name] ? (
    <img src={CalenderRedIcon} alt="Icon" width={25} height={25} />
  ) : (
    <img src={CalenderIcon} alt="Icon" width={25} height={25} />
  );
}

export default NewTimeIcon;
